module.exports = __webpack_public_path__ + "static/img/arduino_mega_2560_cabo-1.9d67596.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/arduino_mega_2560_cabo-1.svg
// module id = pc73
// module chunks = 0